import { render, staticRenderFns } from "./input-switch.vue?vue&type=template&id=7c6db374&scoped=true&"
import script from "./input-switch.vue?vue&type=script&lang=js&"
export * from "./input-switch.vue?vue&type=script&lang=js&"
import style0 from "./input-switch.vue?vue&type=style&index=0&id=7c6db374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6db374",
  null
  
)

export default component.exports